import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ETextSize } from '../../common/enums/index.enum';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AdditionalInformation',
  props: {
    size: { default: ETextSize.MD },
    text: null,
    title: null
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(["ccn-cookie-additional-details", `ccn-cookie-additional-details--${__props.size}`])
  }, _toDisplayString(__props.title) + ": " + _toDisplayString(__props.text), 3))
}
}

})